import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DialogActionsComponent, DialogComponent, DialogTitleBarComponent } from '@progress/kendo-angular-dialog';
import { TextAreaDirective } from '@progress/kendo-angular-inputs';
import { ProjectEstimateNote } from '../model';

@Component({
  selector: 'app-estimate-notes-form',
  templateUrl: './estimate-notes-form.component.html',
  styleUrls: ['./estimate-notes-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DialogActionsComponent,
    DialogComponent,
    DialogTitleBarComponent,
    FormsModule,
    ReactiveFormsModule,
    TextAreaDirective,
  ],
})

export class EstimateNotesFormComponent {

  readonly model = input<ProjectEstimateNote>(undefined);

  constructor() {
    effect(() => {
      let note = this.model();
      this.notes = note === undefined ? '' : note.RecordDescription;
      this.editForm.reset(note);
      this.active = note !== undefined;
    })
  }

  public active = false;
  public maxChars = 2000;
  public notes = '';
  public chars = 0;

  readonly cancel = output<any>();
  readonly save = output<any>();

  public editForm: UntypedFormGroup = new UntypedFormGroup({
    'ProjectEstimateId': new UntypedFormControl(),
    'RecordDescription': new UntypedFormControl()
  });

  public onSave(e): void {
    e.preventDefault();
    this.save.emit(this.editForm.value);
    this.active = false;
  }

  public onCancel(e): void {
    e.preventDefault();
    this.closeForm();
  }

  public closeForm(): void {
    this.active = false;
    this.cancel.emit(null);
  }
}